import React, { Component } from 'react'
import cx from 'classnames'

import './Tabs.scss'

export default class Tabs extends Component {
  changeTab = (e, active) => {
    const { onChange } = this.props
    e.preventDefault()
    return onChange && onChange(active)
  }

  renderItem = (item, index, array) => {
    const { active } = this.props
    const {
      'aria-label': itemAriaLabel,
      href: itemHref,
      id: itemId,
      isDisabled: itemIsDisabled,
      text: itemText,
    } = item || {}
    const className = cx('Tabs__item', {
      active: active === itemId,
      disabled: !!itemIsDisabled,
      'Tabs__item--is-disabled': !!itemIsDisabled,
    })
    const isSingleItem = array.length === 1

    // Support both string and React element as text
    const isTextString = typeof itemText === 'string'
    const ariaLabel = itemAriaLabel || (isTextString ? itemText : itemId)
    const qaId = isTextString
      ? `learner-${itemText}-tab`.toLowerCase()
      : `learner-${itemId}-tab`.toLowerCase()

    return (
      <a
        aria-label={ariaLabel}
        qa-id={qaId}
        className={className}
        href={itemIsDisabled || isSingleItem ? '#' : itemHref}
        key={itemId}
        onClick={
          itemIsDisabled || isSingleItem
            ? (e) => {
                e.preventDefault()
              }
            : (e) => this.changeTab(e, item)
        }
      >
        {itemText}
      </a>
    )
  }

  render() {
    const { children, className, isAlt, items } = this.props
    const classNames = cx(
      'Tabs',
      {
        alt: isAlt,
      },
      className,
    )

    return (
      <div className={classNames} qa-id="learner-tabs">
        {children ? children : items.map(this.renderItem)}
      </div>
    )
  }
}
